<template>
    <div>
      <ul class="custom-icon-list">
          <li class="py-1" v-for="(item,index) in dataList" :key="index" :style="getIconStyle">
            <!-- {{ item.name }} -->
            {{ $t(`${item.lang}.${index}`) }}
          </li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'IconListStyle',
  props: {
    dataList: {
      type: [Object, Array],
      required: true
    },
    svgIcon: {
      type: String,
      default: null
    }
  },
  computed: {
    getIconStyle () {
      const icon = this.svgIcon
      if (!icon) {
        return {}
      }
      return {
        '--icon-url': `url('/static/img/icons/${icon}')`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../static/sass/page/ac_cleaning.scss';
.custom-icon-list {
  list-style: none;
  padding-left: 0;

  li {
    position: relative;
    padding-left: 32px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 6.5px;
      width: 20px;
      height: 20px;
      background-image: var(--icon-url);
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/materials/IconListStyle.vue